import axios from "axios";
import { getToken } from "./auth.api";

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL });

api.interceptors.request.use(config => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem("auth_token");
      localStorage.removeItem("auth_user");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const getSetupSprint    = ()                          => api.get("/setup/sprint").then(r => r.data);
export const putSetupSprint    = (body)                      => api.put("/setup/sprint", body).then(r => r.data);
export const getSetupTickets   = ()                          => api.get("/setup/tickets").then(r => r.data);
export const postSetupTickets  = (tickets, programacao_tipo) => api.post("/setup/tickets", { tickets, programacao_tipo }).then(r => r.data);
export const deleteSetupTicket = (id)                        => api.delete(`/setup/tickets/${id}`).then(r => r.data);
export const getSetupResponsaveis   = ()                     => api.get("/setup/responsaveis").then(r => r.data);
export const putTicketResponsavel   = (idTicket, responsavel) =>
  api.put(`/tickets/${idTicket}/responsavel`, { responsavel }).then(r => r.data);
